import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectVariableOverview } from "../../CommonComponents/CommonProjectVariableViews";
export const ProjectVariableAllRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().variables.all,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectVariableOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
